import { Injectable } from '@angular/core';
import {NetworkApiService} from '../../../../services/api/network/online/network/network-api.service';
import {ConnectionApiService} from '../../../../services/api/network/online/connection/connection-api.service';
import {NodeApiService} from '../../../../services/api/network/online/node/node-api.service';
import {VoipPeerApiService} from '../../../../services/api/network/online/voip-peer/voip-peer-api.service';
import {QualityBasedRoutingApiService} from '../../../../services/api/settings/routing/quality-based-routing/quality-based-routing-api.service';
import {LogicalConjunctionService} from '../../../../services/common/logical-conjunction/logical-conjunction.service';
import {CallsQuotaApiService} from '../../../../services/api/settings/routing/calls-quota/calls-quota-api.service';
import {PeerConnectionApiService} from '../../../../services/api/peer-connection/peer-connection-api.service';
import {AttributeManipulationGroupsApiService} from '../../../../services/api/settings/call-flow-configurations/attribute-manipulation-groups/attribute-manipulation-groups-api.service';
import {RoutingServersSettingsApiService} from '../../../../services/api/routing-servers/routing-servers-settings-api.service';
import {CacProfilesApiService} from '../../../../services/api/routing/cac-profiles/cac-profiles-api.service';
import {SipReasonsApiService} from '../../../../services/api/routing/sip-reason/sip-reasons-api.service';
import {RoutingSettingsApiService} from '../../../../services/api/settings/routing/routing-settings/routing-settings-api.service';
import {PconsDialogService} from '../../../pcons/pcons-dialog/pcons-dialog.service';
import {forkJoin} from 'rxjs';
import {MapService} from '../../map/map/map.service';
import {VirtualPconsDialogService} from '../../../pcons/virtual-pcons-dialog/virtual-pcons-dialog.service';
import Search from '../../../../utils/search';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmationDialogComponent} from '../../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {InformationDialogComponent} from '../../../../dialogs/information-dialog/information-dialog.component';
import {TestRouteDialogComponent} from '../../../map/test-route-dialog/test-route-dialog.component';
import {AcDialogService} from 'ac-infra';
import {PconsDetachDialogComponent} from '../../../pcons/pcons-detach-dialog/pcons-detach-dialog.component';
import {
  ShortCallsProfilesApiService
} from '../../../../services/api/settings/routing/short-calls-profiles/short-calls-profiles-api.service';

@Injectable({
  providedIn: 'root'
})
export class OnlinePeerConnectionService {

  constructor(private pconApiService: PeerConnectionApiService,
              private voipPeerApiService: VoipPeerApiService,
              private attributeManipulationGroupsApiService: AttributeManipulationGroupsApiService,
              private qualityBasedRoutingApiService: QualityBasedRoutingApiService,
              private nodeApiService: NodeApiService,
              private connectionApiService: ConnectionApiService,
              private logicalConjunctionService: LogicalConjunctionService,
              private routingServerApiService: RoutingServersSettingsApiService,
              private routingSettingsApiService: RoutingSettingsApiService,
              private pconsDialogService: PconsDialogService,
              private virtualPconsDialogService: VirtualPconsDialogService,
              private networkApiService: NetworkApiService,
              private callsQuotaApiService: CallsQuotaApiService,
              private cacProfilesApiService: CacProfilesApiService,
              private sipReasonsApiService: SipReasonsApiService,
              private shortCallsProfilesApiService: ShortCallsProfilesApiService,
              private acDialogService: AcDialogService,
              private mapService: MapService,
              private dialog: MatDialog) {}

  public lockPcon(id: number): void {
    this.pconApiService.lockPCon(id).then(() => {
      this.refreshDiagram();
    }).catch(() => {});
  }

  public lockPcons(ids): void {
    this.pconApiService.lockPCons(ids).then(() => {
      this.refreshDiagram();
    }).catch(() => {});
  }

  public unlockPcon(id: number): void {
    this.pconApiService.unlockPCon(id).then(() => {
      this.refreshDiagram();
    }).catch(() => {});
  }

  public unlockPcons(ids): void {
    this.pconApiService.unlockPCons(ids).then(() => {
      this.refreshDiagram();
    }).catch(() => {});
  }

  public lockOutgoingPCons(ids): void {
    this.pconApiService.lockOutgoingPCons(ids).then(() => {
      this.refreshDiagram();
    }).catch(() => {});
  }

  public lockIncomingPCons(ids): void {
    this.pconApiService.lockIncomingPCons(ids).then(() => {
      this.refreshDiagram();
    }).catch(() => {});
  }

  public deletePcon(pCon): void {
   /* this.sharedEventService.broadcast('openConfirmationDialogWindow',
      `Are you sure you want to delete this peer connection: "${pCon.name}" ?`, 'Delete', () => {
      this.pconApiService.deletePCon(pCon.id)
        .then(() => {
          this.sharedEventService.broadcast('closeConfirmationDialogWindow');
          this.refreshDiagramAndTable();
        }).catch(() => {
        this.sharedEventService.broadcast('closeConfirmationDialogWindow');
      });
    });*/

    this.virtualPconsDialogService.remove(pCon, () => {
      this.refreshDiagram();
    });
  }

  public deletePcons(pCons): void {
    const ids = pCons.map(pCon => pCon.id);
    const confirmationMessage = `Are you sure you want to delete ${ids.length === 1 ?
        `the peer connection: "${pCons[0].name.text}"` :
        `${ids.length} peer connections: ${this.logicalConjunctionService.generateAndDescription(
            pCons.map(item => item.name), 'text')}`} ?`;

    /*this.sharedEventService.broadcast('openConfirmationDialogWindow', confirmationMessage, 'Delete', () => {
      this.pconApiService.deletePCons(ids)
        .then(() => {
          this.sharedEventService.broadcast('closeConfirmationDialogWindow');
          this.refreshDiagramAndTable();
        }).catch(() => {
        this.sharedEventService.broadcast('closeConfirmationDialogWindow');
      });
    });*/
  }

  public detachPCon(id: number): void {
    const detachObject = { name: ''};
    this.acDialogService.open(PconsDetachDialogComponent, {
      dialogData: detachObject,
      onSubmit: () => {
        this.pconApiService.detachPCon(id, detachObject.name).then(() => {
          this.refreshDiagram();
        }).catch(() => {});
      }
    });
  }

  public editPcon(id: number): void {
    forkJoin({
      pCon: this.pconApiService.getPcon(id),
      voipPeers: this.voipPeerApiService.getVoipPeersForMap(),
      attrManipulation: this.attributeManipulationGroupsApiService.getAttributeManipulationGroups(),
      callsQuota: this.callsQuotaApiService.getCallsQuotas(),
      cacProfiles: this.cacProfilesApiService.getCacProfiles(),
      sipReasons: this.sipReasonsApiService.getSipReasonGroups(),
      advancedConditions: this.qualityBasedRoutingApiService.getQualityBasedRoutingSettings(),
      shortCallsProfiles: this.shortCallsProfilesApiService.getShortCallsProfiles()
    }).subscribe(data => {

      const voipPeersOptions = Search.generateSearchOptions(data.voipPeers.elements, 'name', 'id');
      const attrManipulation = Search.generateSearchOptions(data.attrManipulation, 'groupName', 'id');
      const callsQuotaOptions = Search.generateSearchOptions(data.callsQuota.elements, 'name', 'id');
      const cacProfilesOptions = Search.generateSearchOptions(data.cacProfiles.elements, 'name', 'id');
      const sipReasonsOptions = Search.generateSearchOptions(data.sipReasons, 'name', 'id');
      const shortCallsProfilesOptions = Search.generateSearchOptions(data.shortCallsProfiles.elements, 'name', 'id');

      this.pconsDialogService.editPCon(data.pCon, voipPeersOptions, attrManipulation,
        callsQuotaOptions, cacProfilesOptions, sipReasonsOptions, data.advancedConditions, shortCallsProfilesOptions, () => {
          this.refreshDiagram();
        });
    });
  }

  public addVirtualPCon(fromNode: any, toVoipPeer: any): void {
    const pCon = {
      nodeId: fromNode.id,
      nodeName: fromNode.name,
      voipPeerId: toVoipPeer ? toVoipPeer.id : null,
      weight: 50,
      peerConnectionNodeType: 'Virtual'
    };

    this.voipPeerApiService.getVoipPeersForMap().then(voipPeers => {
      const voipPeersOptions = Search.generateSearchOptions(voipPeers.elements, 'name', 'id');

      this.virtualPconsDialogService.addVirtualPcon(pCon, voipPeersOptions, () => {
        this.refreshDiagram();
      });
    });
  }

  public editVirtualPCon(id: number): void {
    forkJoin({
      pCon: this.pconApiService.getPcon(id),
      voipPeers: this.voipPeerApiService.getVoipPeersForMap()
    }).subscribe(data => {
      const voipPeersOptions = Search.generateSearchOptions(data.voipPeers.elements, 'name', 'id');
      this.virtualPconsDialogService.editVirtualPcon(data.pCon, voipPeersOptions, () => {
        this.refreshDiagram();
      });
    });
  }

  public testRoute(selectedPConId: number, testRouteRequest?): void {
    const isRepeatRequest = !!testRouteRequest;
    const testRouteObject = {};

    Promise.all([this.routingSettingsApiService.getRoutingSettings().toPromise(),
      this.pconApiService.getPConsForMap(),
      this.nodeApiService.getNodesForMap(),
      this.connectionApiService.getConnectionsForMap(),
      this.routingServerApiService.getRoutingServers().toPromise()]).then((value) => {
      const dataObject: any = {
        testRouteParameters: value[0],
        pCons: value[1].elements,
        nodes: value[2],
        connections: value[3].elements
      };

      dataObject.routers = value[4].filter(router => {
        return router.adminState === 'UNLOCKED' && router.status === 'AVAILABLE';
      });

      const selectedPCon = dataObject.pCons.find((pCon) => {
        return  pCon.id === selectedPConId;
      });

      if (isRepeatRequest && !selectedPCon) {
        // this.sharedEventService.broadcast('openInformationDialogWindow', 'Peer Connection does not exist');
        const dialogRef = this.dialog.open(InformationDialogComponent, {
          width: '460px',
          data: {
            message: 'Peer Connection does not exist'
          }
        });

        dialogRef.componentInstance.onApply.subscribe(() => {
          dialogRef.close();
        });
        return;
      }

      if (selectedPCon && (selectedPCon.adminState === 'LOCKED' || selectedPCon.adminState === 'LOCKED_INCOMING')) {
        const message = `Peer Connection ${selectedPCon.name} is locked ${(selectedPCon.adminState === 'LOCKED_INCOMING' ?
          ' for incoming' : '' )} . \nDo you want to continue with test route ?`;
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
          width: '460px',
          data: { message }
        });

        dialogRef.componentInstance.onApply.subscribe(() => {
          this.testRouteInner(selectedPConId, testRouteObject, dataObject, isRepeatRequest);
          dialogRef.close();
        });
      } else {
        this.testRouteInner(selectedPConId, testRouteObject, dataObject, isRepeatRequest);
      }
    });
  }

  private editPconInServer(pCon, id: number): void {
    this.pconApiService.editPCon(pCon, id).then(() => {
      // this.sharedEventService.broadcast('closePeerConnectionDialog');
      this.refreshDiagram();
    }).catch(() => {});
  }

  private addVirtualPconInServer(pCon): void {
    this.pconApiService.addPCon(pCon).then(() => {
      // this.sharedEventService.broadcast('closeVirtualPeerConnectionDialog');
      this.refreshDiagram();
    }).catch(() => {});
  }

  private editVirtualPconInServer(pCon, id: number): void {
    this.pconApiService.editPCon(pCon, id).then(() => {
      // this.sharedEventService.broadcast('closeVirtualPeerConnectionDialog');
      this.refreshDiagram();
    }).catch(() => {});
  }

  private testRouteInner(selectedPConId: number, testRouteObject, dataObject, repeat): void {
    testRouteObject.maxRoutes = dataObject.testRouteParameters.maxRoutes;
    testRouteObject.maxRoutesPerDestination = dataObject.testRouteParameters.maxRoutesPerAction;
    delete dataObject.testRouteParameters;

    const dialogData: any = {
      testRouteObject,
      selectedPConId,
      dataObject,
      repeat
    };

    this.acDialogService.open(TestRouteDialogComponent, {
      dialogData,
      onSubmit: () => {
        this.networkApiService.testRoute(testRouteObject).then((testRouteResult) => {
          this.mapService.testRoute({testRouteObject, testRouteResult});
        }).catch(() => {});
      }
    });
  }

  private refreshDiagram(): void {
    this.mapService.refresh();
  }
}
